import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/d4dbae95-204b-4d0e-80f4-643d00b52d20.png"
              alt="Proform Chimney Systems"
              className="h-20 w-auto mb-6"
            />
            <p className="text-gray-400 leading-relaxed mb-6">
              Innovative and reliable chimney manufacturing company in Turkey, providing the highest quality chimney systems for residential, commercial, and industrial applications.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/proform-chimney-system/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 bg-gray-800 rounded-xl flex items-center justify-center hover:bg-orange-500 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:shadow-lg"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/proformbaca/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 bg-gray-800 rounded-xl flex items-center justify-center hover:bg-orange-500 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:shadow-lg"
              >
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer flex items-center space-x-2 group">
                  <i className="ri-arrow-right-s-line text-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                  <span>Home</span>
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer flex items-center space-x-2 group">
                  <i className="ri-arrow-right-s-line text-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                  <span>Services</span>
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer flex items-center space-x-2 group">
                  <i className="ri-arrow-right-s-line text-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                  <span>About Us</span>
                </Link>
              </li>
              <li>
                <Link to="/certificates" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer flex items-center space-x-2 group">
                  <i className="ri-arrow-right-s-line text-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                  <span>Certificates</span>
                </Link>
              </li>
              <li>
                <Link to="/catalog" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer flex items-center space-x-2 group">
                  <i className="ri-arrow-right-s-line text-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                  <span>Catalog</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Our Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services/double-wall" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer flex items-center space-x-2 group">
                  <i className="ri-arrow-right-s-line text-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                  <span>Double Wall Systems</span>
                </Link>
              </li>
              <li>
                <Link to="/services/single-wall" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer flex items-center space-x-2 group">
                  <i className="ri-arrow-right-s-line text-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                  <span>Single Wall Systems</span>
                </Link>
              </li>
              <li>
                <Link to="/services/hermetic" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer flex items-center space-x-2 group">
                  <i className="ri-arrow-right-s-line text-orange-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                  <span>Hermetic Systems</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-fill text-orange-500 text-xl mt-1 flex-shrink-0"></i>
                <span className="text-gray-400 leading-relaxed">
                  Akçaburgaz Mah. 3028 Sk. No:1<br />
                  İç Kapı No:27<br />
                  Esenyurt / Istanbul, Turkey
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-fill text-orange-500 text-xl flex-shrink-0"></i>
                <a href="tel:+905434576196" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer">
                  +90 543 457 61 96
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-fill text-orange-500 text-xl flex-shrink-0"></i>
                <a href="mailto:info@proformbaca.com" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer">
                  info@proformbaca.com
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-time-fill text-orange-500 text-xl flex-shrink-0"></i>
                <span className="text-gray-400">
                  Mon-Fri: 9:00 AM - 6:00 PM
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Proform Chimney Systems. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm">
              <Link to="/contact" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer">
                Privacy Policy
              </Link>
              <span className="text-gray-600">|</span>
              <Link to="/contact" className="text-gray-400 hover:text-orange-500 transition-colors duration-300 cursor-pointer">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}